import { ApiConfigurationFormContext } from './api-configuration-form-context';

export class ApiConfigurationDetailContext {
    public editedRestApiConfigurationId: number = null;

    public apiConfigurationContext: ApiConfigurationFormContext = new ApiConfigurationFormContext();
}
